import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {BUSINESS_NAME} from "@/content";
import { GENERAL_SERVICE_TERM_3} from "@/content/services/stand-alone-services";
import {whyUs, WhyUsType} from "@/content/why-us/why-us";
import ContentTitles from "@/ui/content-titles/content-titles";
import ImageFormatter from "@/ui/image-formatter/image-formatter";
import Link from "next/link";

export const WhyUs = ({hideButton}) => {
    return (
        <Box p={3}>
            <ContentTitles
                title={`Why ${BUSINESS_NAME}?`}
                subTitle={`Six reasons to use our ${GENERAL_SERVICE_TERM_3}`}
                subTitleComponent='h3'
                subTitleVariant='h5'
                titleComponent='h4'
                titleVariant='h4'
            />

            <div className="grid gap-10 lg:grid-cols-6 sm:grid-cols-3 xs:grid-cols-2 justify-center ">
                {whyUs.map(({description, title, id, image} : WhyUsType) => (
                    <div key={id} className="text-center pt-6 sm:bg-transparent bg-white sm:rounded-lg rounded-[60%] sm:shadow-none shadow-md p-3 grid items center space-y-3 w-[320px] sm:w-auto sm:h-[auto] h-[320px] items-center expand-in-out fade-in">
                        <div className="flex align-center flex-col">
                            <div className='flex justify-center '>
                                <ImageFormatter src={image.url} title={image.alt} alt={image.alt}
                                                className="lg:h-[110px] h-[75px]"
                                />
                
                            </div>
                            <Typography variant='h6' component='h5' className="text-[20px] lg:text-[14px] text-center slide-down !py-0 !my-0">
                                {title}
                            </Typography>
                            {description && <Typography variant='body1' component='h6' className="!text-[14px] slide-down">
                                {description}
                            </Typography> }
                        </div>
                    </div>
                ))}
            </div>

            {!hideButton && (
                <Box py={4} className="text-center">
                    <Button variant="outlined" href='/about' color="secondary" component={Link}
                            className="bg-white">
                        More about {BUSINESS_NAME}
                    </Button>
                </Box>
            )}
        </Box>
    );
};
